<template>
<div>
  <b-container
    fluid
    v-if="!assetsUnavailable"
  >
    <b-row align-h="between">
      <b-col
        md="auto"
        cols="12"
      >
        <s-search-input
          v-model="searchTerm"
          v-s-trigger="getReportsByFilter"
          :placeholder="$t('reports.search-report')"
        />
      </b-col>
      <b-col
        md="auto"
        cols="12"
      >
        <b-button
          variant="primary"
          class="mt-3 mt-md-0"
          @click="newReport"
        >
        {{ $t('reports.new-report') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row
      align-h="center"
      class="my-3"
    >
      <oscillography-list
        @refresh-list="getReports"
        :pagination="pagination"
        :reports="reports"
        :loading="loading"
        :sort-by.sync="sortBy"
        @page-changed="pageChanged"
        @sort-changed="sort"
      />
    </b-row>
  </b-container>
  <b-container
    fluid
    v-else
  >
    <reports-unavailable />
  </b-container>
</div>
</template>
<style lang="sass" scoped>
  .view-report
    &__loader-container
      min-height: 500px
</style>

<script>
import OscillographyService from '@/domain/services/generalPanel/reports/oscillography';
import LoadingMixin from '@/services/loadingMixin';
import OscillographyList from '@/domain/components/generalPanel/reports/oscillography/List';
import ReportsUnavailable from '@/domain/components/generalPanel/reports/oscillography/ReportsUnavailable';

const nameMapper = name => ({ name });

export default {
  name: 'ViewReport',
  components: {
    OscillographyList,
    ReportsUnavailable,
  },
  mixins: [
    LoadingMixin,
  ],
  data: () => ({
    searchTerm: null,
    lastSearchTerm: null,
    reports: [],
    assets: [],
    pagination: {
      perPage: 10,
      currentPage: 1,
      totalRows: null,
    },
    sortBy: {
      field: 'reportName',
      desc: false,
    },
  }),
  computed: {
    assetsUnavailable() {
      return !this.assets.length && !this.loading;
    },
    effectiveTermToSearch() {
      return this.searchTerm && this.searchTerm.length >= 2 ? this.searchTerm : null;
    },
  },
  methods: {
    getReportsByFilter() {
      if (this.effectiveTermToSearch === this.lastSearchTerm) {
        return;
      }

      this.lastSearchTerm = this.effectiveTermToSearch;
      this.$set(this.pagination, 'currentPage', 1);
      this.getReports();
    },
    pageChanged(newPage) {
      this.$set(this.pagination, 'currentPage', newPage);
      this.getReports();
    },
    sort({ sortBy, sortDesc }) {
      if (!sortBy) return;
      this.sortBy.field = sortBy;
      this.sortBy.desc = sortDesc;
      this.pageChanged(1);
    },
    getReports() {
      this.startLoading();
      const { perPage, currentPage } = this.pagination;
      const payload = {
        filter: {
          reportName: this.searchTerm,
        },
        pageSize: perPage,
        page: currentPage,
        sort: {
          [this.sortBy.field]: this.sortBy.desc ? 'desc' : 'asc',
        },
      };
      OscillographyService.getReportList(payload)
        .then(({ data, total }) => {
          this.reports = data.map(report => ({
            ...report,
            installations: (report.installations || []).map(nameMapper),
            assets: (report.assets || []).map(nameMapper),
          }));
          this.pagination.totalRows = total;
        })
        .finally(() => {
          this.endLoading();
        });
    },
    newReport() {
      this.$router.push({ name: 'reports.oscillography.new-report' });
    },
    getAssets() {
      this.startLoading();
      OscillographyService
        .getAssets({})
        .then((response) => {
          this.assets = response;
        })
        .finally(() => {
          this.endLoading();
        });
    },
  },
  created() {
    this.getReports();
    this.getAssets();
  },
};
</script>
